module.exports = __webpack_public_path__ + "img/_6.ccba6599.png";